module.exports = __webpack_public_path__ + "static/media/engrenagem.992c6968.svg";